import { State } from './state';
import { Document } from './document';

export class Creci extends Document {

    constructor(number: string = '', public state: State = State.SC, verified: boolean = false) {
        super(number, verified);
    }
}